<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue'

// Лёгкий декоративный фон: пастельные «пузырьки», медленно дрейфующие
// и уплывающие за край. Vanilla canvas, без зависимостей.
const canvas = ref<HTMLCanvasElement | null>(null)
const COLORS = ['#efe6e6', '#fde6e6', '#FEF0EB']
const COUNT = 90

let raf = 0
let particles: { x: number; y: number; r: number; vx: number; vy: number; color: string }[] = []

onMounted(() => {
  const el = canvas.value
  if (!el) return
  const ctx = el.getContext('2d')
  if (!ctx) return

  const dpr = Math.min(window.devicePixelRatio || 1, 2)
  let w = 0
  let h = 0

  const resize = () => {
    w = el.clientWidth
    h = el.clientHeight
    el.width = w * dpr
    el.height = h * dpr
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
  }

  const rand = (min: number, max: number) => Math.random() * (max - min) + min

  const seed = () => {
    particles = Array.from({ length: COUNT }, () => ({
      x: rand(0, w),
      y: rand(0, h),
      r: rand(2, 11),
      vx: rand(-0.35, 0.35),
      vy: rand(-0.35, 0.35),
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
    }))
  }

  const draw = () => {
    ctx.clearRect(0, 0, w, h)
    ctx.globalAlpha = 0.75
    for (const p of particles) {
      p.x += p.vx
      p.y += p.vy
      if (p.x < -p.r) p.x = w + p.r
      else if (p.x > w + p.r) p.x = -p.r
      if (p.y < -p.r) p.y = h + p.r
      else if (p.y > h + p.r) p.y = -p.r
      ctx.beginPath()
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2)
      ctx.fillStyle = p.color
      ctx.fill()
    }
    raf = requestAnimationFrame(draw)
  }

  resize()
  seed()
  draw()

  window.addEventListener('resize', () => {
    resize()
    seed()
  })
})

onBeforeUnmount(() => cancelAnimationFrame(raf))
</script>

<template>
  <canvas ref="canvas" />
</template>
